import { DATA_TYPE_CODE } from '~/web-frontend-core/api/const/base';
import LiveOutcomes from '~/web-frontend-core/api/connector/outcomes/Base';
export default class LiveOutcomesTable extends LiveOutcomes {
    constructor() {
        super(...arguments);
        this.dataTypeCode = DATA_TYPE_CODE.LIVE_OUTCOMES_TABLE;
    }
}



// WEBPACK FOOTER //
// ./src/web-frontend-core/api/connector/outcomes/live/Table.js